import { BAOCustomElement } from '@bao/custom-element'

class PageDrawer extends BAOCustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.checkFormValidation()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(document, 'click', this.handleClick.bind(this))
  }

  handleClick (event) {
    const drawerLinkEl = event.target.closest('a[href^="#drawer-"]')
    if (!drawerLinkEl) return
    event.preventDefault()

    const drawerKey = drawerLinkEl.href.split('#drawer-')[1]
    window.drawers.activeDrawerKey = drawerKey
  }

  checkFormValidation () {
    if (!this.els) return
    if (!this.els.success?.exists && !this.els.errors?.exists) return

    window.drawers.activeDrawerKey = this.drawerKey
  }

  get drawerKey () {
    return this.dataset.drawerKey || ''
  }
}

if (!customElements.get('page-drawer')) {
  customElements.define('page-drawer', PageDrawer)
}
